import { render, staticRenderFns } from "./IconSvgTarget.vue?vue&type=template&id=15b3c6db&scoped=true&"
import script from "./IconSvgTarget.vue?vue&type=script&lang=js&"
export * from "./IconSvgTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b3c6db",
  null
  
)

export default component.exports